import React from 'react';
import { useTranslation } from 'react-i18next';

export const NoPermission: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="flex items-center justify-center h-full">
            <div className="text-center text-gray-500">
                <div className="text-xl mb-2">{t('common.noPermission')}</div>
                <div>{t('common.contactAdmin')}</div>
            </div>
        </div>
    );
};
